import { render, staticRenderFns } from "./bc.vue?vue&type=template&id=9667f358&scoped=true"
import script from "./bc.vue?vue&type=script&lang=js"
export * from "./bc.vue?vue&type=script&lang=js"
import style0 from "./bc.vue?vue&type=style&index=0&id=9667f358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9667f358",
  null
  
)

export default component.exports